import React, { createContext, useContext } from "react";

interface MessageContextValues {
  isFormVisible: boolean;
  isFormSuccessVisible: boolean;
  onShowForm: () => void;
  onResetPrompt: () => void;
}

const MessageContext = createContext<MessageContextValues>({
  isFormSuccessVisible: false,
  isFormVisible: false,
  onShowForm: () => {},
  onResetPrompt: () => {},
});

const MessageProvider: React.FC<MessageContextValues> = ({
  children,
  ...props
}) => {
  return (
    <MessageContext.Provider value={props}>{children}</MessageContext.Provider>
  );
};

export const useMessageContext = (): MessageContextValues =>
  useContext(MessageContext);

export default MessageProvider;
